import { useState } from "react";
import "../Login/Login.scss";
import ButtonComponent from "../../components/ButtonComponent/ButtonComponent";
import InputField from "../../components/InputField/InputField";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import { errorToast, successToast } from "../../services/ToastHelper";
import { FORGOT_PASSWORD } from "../../utils/apiPath";
import { postApi } from "../../utils/apiService";

import AuthLogo from "../../assets/appLogo";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setEmail(e.target.value);
    setError("");
  };

  const validateField = () => {
    let newError = "";
    if (!email) {
      newError = "Email is required";
    } else if (/\s/.test(email)) {
      newError = "Email should not contain spaces";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
      newError = "Please enter a valid email address";
    }

    setError(newError);
    return newError === "";
  };

  const handleForgotPassword = async () => {
    if (!validateField()) return;

    setIsLoading(true);
    try {
      const payload = { email };
      const { statusCode, message } = await postApi(FORGOT_PASSWORD, payload);

      if (statusCode === 200) {
        successToast("Password reset link sent to your email!");
        navigate("/");
      } else {
        errorToast(message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      {isLoading && <Loader />}

      <div className="login-wrap">
        <div className="login-logo">
          <img src={AuthLogo} alt="main-logo" />
        </div>

        <div className="login-card">
          <h1 className="title">Forgot Password</h1>
          <p className="subtitle">Enter your email to receive a password reset link</p>

          <div className="form">
            <InputField
              title="Email"
              name="email"
              value={email}
              onChange={handleChange}
              placeholder="Enter your email"
              required
              errorText={error}
              onKeyDown={(e) => e.key === "Enter" && handleForgotPassword()}
            />

            <ButtonComponent type="submit" variant="primary" onClick={handleForgotPassword}>
              Send Reset Link
            </ButtonComponent>

            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <span 
                className="link" 
                style={{ cursor: "pointer" }} 
                onClick={() => navigate("/")}
              >
                Back to Login
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
